var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('h3',{staticClass:"title"},[_vm._v("Search results:")]),_c('drinks-list',{attrs:{"drinks":_vm.drinks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }